import alfa from "../assets/bank-providers/alfa.svg";
import avangard from "../assets/bank-providers/avangard.svg";
import gazprombank from "../assets/bank-providers/gazprombank.svg";
import homecredit from "../assets/bank-providers/homecredit.svg";
import mts from "../assets/bank-providers/mts.svg";
import other from "../assets/bank-providers/other.svg";
import otkritie from "../assets/bank-providers/otkritie.svg";
import pochtabank from "../assets/bank-providers/pochtabank.svg";
import psb from "../assets/bank-providers/psb.svg";
import raif from "../assets/bank-providers/raif.svg";
import rncb from "../assets/bank-providers/rncb.svg";
import rosbank from "../assets/bank-providers/rosbank.svg";
import rsb from "../assets/bank-providers/rsb.svg";
import rshb from "../assets/bank-providers/rshb.svg";
import sber from "../assets/bank-providers/sber.svg";
import tinkoff from "../assets/bank-providers/tinkoff.svg";
import vtb from "../assets/bank-providers/vtb.svg";
import defaultIcon from "../assets/bank-providers/default.svg";

export const APP__ROUTES = {
  main: "/",
  offer: ":offerId",
  test: "/test",
};

export const API_URL = process.env.REACT_APP_API_URL;

export const BANK__ICONS: any = {
  alfa,
  avangard,
  gazprombank,
  homecredit,
  mts,
  other,
  otkritie,
  pochtabank,
  psb,
  raif,
  rncb,
  rosbank,
  rsb,
  rshb,
  sber,
  tinkoff,
  vtb,
  default: defaultIcon,
};

export const BANK__NAMES: any = {
  alfa: "Альфа",
  avangard: "Авангард",
  gazprombank: "Газпромбанк",
  homecredit: "Хоумбанк",
  mts: "Мтсбанк",
  other: "Любой банк",
  otkritie: "Открытие",
  pochtabank: "Почтабанк",
  psb: "Промсвязьбанк",
  raif: "Райффайзен",
  rncb: "РНКБ",
  rosbank: "Росбанк",
  rsb: "Русский Стандарт",
  rshb: "Россельхозбанк",
  sber: "Сбер",
  tinkoff: "Т-Банк(Тинькофф)",
  vtb: "ВТБ",
  dushanbecity: "Душанбе Сити",
};

// Сигнатуры сопоставляются по префиксу (matchesSignature), не по полному равенству.
// JPEG значим первыми тремя байтами FF D8 FF — 4-й байт это номер APPn-сегмента (E0/E1/
// E2/E3/E8/DB/EE...), в признак формата он не входит и его проверка резала легальные фото.
export const SIGNATURES = {
  png: ["89504e47"],
  jpg: ["ffd8ff"],
  pdf: ["25504446"],
};
